import { genUUIDv4 } from '@/utils/id_generator';
import MusicIcon from '@/assets/img/playground/playground_music.svg';
import ChatIcon from '@/assets/img/playground/playground_chat.svg';
import DrawIcon from '@/assets/img/playground/playground_draw.svg';
import VideoIcon from '@/assets/img/playground/playground_video.svg';
import PictureBookIcon from '@/assets/img/playground/playground_picture_book.svg';

const getPlayGroundList = () => {
    return [
        {
            id: genUUIDv4(),
            name: "音乐制作",
            introduce: "用AI制作属于你的音乐",
            coverImg: MusicIcon,
            path: "/playground/bobo-music",
            beta: true,
            onlyTeacherVisible: false,
        },
        {
            id: genUUIDv4(),
            name: "AI聊天",
            introduce: "和AI聊天，让AI成为你的好朋友",
            coverImg: ChatIcon,
            path: `/playground/chat`,
            beta: true,
            onlyTeacherVisible: false,
        },
        {
            id: genUUIDv4(),
            name: "AI作画",
            introduce: "用AI创作你钟意的图片",
            coverImg: DrawIcon,
            path: "/playground/draw",
            beta: true,
            onlyTeacherVisible: false,
        },
        {
            id: genUUIDv4(),
            name: "视频生成",
            introduce: "用AI制作属于你的视频",
            coverImg: VideoIcon,
            path: "/playground/video",
            beta: true,
            onlyTeacherVisible: false,
        },
        // {
        //    id: genUUIDv4(),
        //    name: "AI聊天WS测试",
        //    introduce: "和AI聊天，让AI成为你的好朋友",
        //    coverImg: ChatIcon,
        //    path: "/playground/ai-chat-ws",
        // },
        {
            id: genUUIDv4(),
            name: "绘本制作",
            introduce: "用AI制作属于你的绘本",
            coverImg: PictureBookIcon,
            path: "/coursestudy/105/96/160",
            beta: true,
            onlyTeacherVisible: true,
        },
    ]
}

export default getPlayGroundList;
